import { useMemo } from 'react';
import { usePathname, useSearchParams } from '@framework/next/navigation';
import { useFeatureToggleContext } from '@framework/ui/Organisms/FeatureToggle/Context';
import Market from '@/creditflowresearch/domain/Market';
import Region from '@/creditflowresearch/domain/Region';
import Product from '@/creditflowresearch/domain/Product';
import Segment from '@/creditflowresearch/domain/Segment';
import { isAccessGranted } from './resolveGrant';
import { GrantContext } from './IAccessGrant';

export const useAccessGrant = (extra?: Partial<GrantContext>) => {
  const { getFeatureByName } = useFeatureToggleContext();
  const asPath = usePathname();
  const searchParams = useSearchParams();
  const markets = searchParams.get('markets');
  const products = searchParams.get('products');
  const regions = searchParams.get('regions');
  const segments = searchParams.get('segments');

  return useMemo(() => {
    const context: GrantContext = {
      marketIds: Market.getIds(markets),
      regionIds: Region.getIds(regions),
      productIds: Product.getIds(products),
      sectorIds: Segment.getIds(segments),
      pathname: asPath,
      ...extra,
    };

    return isAccessGranted(
      context,
      (toggle) => getFeatureByName(toggle).isEnabled,
    );
  }, [markets, products, regions, segments, asPath, extra]);
};
